import React from 'react';
import { AppConfig } from '@aperza/util';
import style from './Header.module.scss';
import AccountNotificationButton from './AccountNotificationButton';
import AccountFavoriteButton from './AccountFavoriteButton';
import AccountUserButton from './AccountUserButton';
import { useAperzaUserContext } from './AperzaUserContext';
import AccountCartButton from './AccountCartButton';
export function AccountHeader() {
    const { serviceType } = useAperzaUserContext();
    return (React.createElement("div", { className: style.accountHeader },
        serviceType === AppConfig.APERZA_EC && React.createElement(AccountCartButton, null),
        React.createElement(AccountNotificationButton, null),
        React.createElement(AccountFavoriteButton, null),
        React.createElement(AccountUserButton, null)));
}
